import "./MiningCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Minasherointroduction from "./sections/Minasherointroduction";
import Principles from "./sections/Principles";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Footer from "@/reusable_sections/Footer";
export default function MiningCaseStudyPage() {
  return <div>
      <Header />
      <Minasherointroduction />
      <Principles />
      <Casestudyshowcase />
      <Footer />
    </div>;
}